import { FIRST_HUE } from '@/color/constants/firstHue';
import { rotateArrayToFirst } from '@/color/helpers/rotateArrayToStart';
const hues = [
    '0.5R',
    '1R',
    '1.5R',
    '2R',
    '2.5R',
    '3R',
    '3.5R',
    '4R',
    '4.5R',
    '5R',
    '5.5R',
    '6R',
    '6.5R',
    '7R',
    '7.5R',
    '8R',
    '8.5R',
    '9R',
    '9.5R',
    '10R',
    '0.5YR',
    '1YR',
    '1.5YR',
    '2YR',
    '2.5YR',
    '3YR',
    '3.5YR',
    '4YR',
    '4.5YR',
    '5YR',
    '5.5YR',
    '6YR',
    '6.5YR',
    '7YR',
    '7.5YR',
    '8YR',
    '8.5YR',
    '9YR',
    '9.5YR',
    '10YR',
    '0.5Y',
    '1Y',
    '1.5Y',
    '2Y',
    '2.5Y',
    '3Y',
    '3.5Y',
    '4Y',
    '4.5Y',
    '5Y',
    '5.5Y',
    '6Y',
    '6.5Y',
    '7Y',
    '7.5Y',
    '8Y',
    '8.5Y',
    '9Y',
    '9.5Y',
    '10Y',
    '0.5GY',
    '1GY',
    '1.5GY',
    '2GY',
    '2.5GY',
    '3GY',
    '3.5GY',
    '4GY',
    '4.5GY',
    '5GY',
    '5.5GY',
    '6GY',
    '6.5GY',
    '7GY',
    '7.5GY',
    '8GY',
    '8.5GY',
    '9GY',
    '9.5GY',
    '10GY',
    '0.5G',
    '1G',
    '1.5G',
    '2G',
    '2.5G',
    '3G',
    '3.5G',
    '4G',
    '4.5G',
    '5G',
    '5.5G',
    '6G',
    '6.5G',
    '7G',
    '7.5G',
    '8G',
    '8.5G',
    '9G',
    '9.5G',
    '10G',
    '0.5BG',
    '1BG',
    '1.5BG',
    '2BG',
    '2.5BG',
    '3BG',
    '3.5BG',
    '4BG',
    '4.5BG',
    '5BG',
    '5.5BG',
    '6BG',
    '6.5BG',
    '7BG',
    '7.5BG',
    '8BG',
    '8.5BG',
    '9BG',
    '9.5BG',
    '10BG',
    '0.5B',
    '1B',
    '1.5B',
    '2B',
    '2.5B',
    '3B',
    '3.5B',
    '4B',
    '4.5B',
    '5B',
    '5.5B',
    '6B',
    '6.5B',
    '7B',
    '7.5B',
    '8B',
    '8.5B',
    '9B',
    '9.5B',
    '10B',
    '0.5PB',
    '1PB',
    '1.5PB',
    '2PB',
    '2.5PB',
    '3PB',
    '3.5PB',
    '4PB',
    '4.5PB',
    '5PB',
    '5.5PB',
    '6PB',
    '6.5PB',
    '7PB',
    '7.5PB',
    '8PB',
    '8.5PB',
    '9PB',
    '9.5PB',
    '10PB',
    '0.5P',
    '1P',
    '1.5P',
    '2P',
    '2.5P',
    '3P',
    '3.5P',
    '4P',
    '4.5P',
    '5P',
    '5.5P',
    '6P',
    '6.5P',
    '7P',
    '7.5P',
    '8P',
    '8.5P',
    '9P',
    '9.5P',
    '10P',
    '0.5RP',
    '1RP',
    '1.5RP',
    '2RP',
    '2.5RP',
    '3RP',
    '3.5RP',
    '4RP',
    '4.5RP',
    '5RP',
    '5.5RP',
    '6RP',
    '6.5RP',
    '7RP',
    '7.5RP',
    '8RP',
    '8.5RP',
    '9RP',
    '9.5RP',
    '10RP',
];
export const MUNSELL_FINE_HUE_STEPS = rotateArrayToFirst(hues, (h) => h === FIRST_HUE);
